import React, { Component } from 'react';
import { Translate } from '$common';



export default class LocationMap extends Component {
  static type = 'location_map';
  static elementName = Translate.get('location_map');
  static icon = 'map';

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/task-form/question-types/location-map.js